import RoutingTip from './RoutingTip';

export default RoutingTip;
